import { render } from "./StrictPhoneNumberInput.vue?vue&type=template&id=1f3ff985&scoped=true"
import script from "./StrictPhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./StrictPhoneNumberInput.vue?vue&type=script&lang=js"

import "./StrictPhoneNumberInput.vue?vue&type=style&index=0&id=1f3ff985&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3ff985"]])

export default __exports__